module.exports = __webpack_public_path__ + "img/two_5.3386a78d.png";